import React from 'react';
import { Separator } from '@components/ui/separator';
import { SidebarTrigger } from '@components/ui/sidebar';
import { Breadcrumbs } from './breadcrumbs';

export const Header = () => (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur">
        <SidebarTrigger />
        <Separator orientation="vertical" className="h-5" />
        <Breadcrumbs />
    </header>
);
